const prefix = "FLIGHT_DETAILS";
const createActionTypes = (resource) => ({
  LOAD: `${prefix}/${resource}/LOAD'`,
  LOADING: `${prefix}/${resource}/LOADING'`,
  LOADED: `${prefix}/${resource}/LOADED'`
});
const loadControlTowerExperienceActionTypes = createActionTypes("LOAD_CONTROL_TOWER_EXPERIENCE");
const loadFlightControlActionTypes = createActionTypes("LOAD_FLIGHT_CONTROL");
const flightDetailsActionTypes = {
  SET_CURRENT_FLIGHT: `${prefix}/SET_CURRENT_FLIGHT`,
  RESET_STATE: `${prefix}/RESET_STATE`
};
const loadFlightControl = (flightId, workspaceId, managementGroup) => {
  return {
    type: loadFlightControlActionTypes.LOAD,
    payload: {
      flightId,
      workspaceId,
      managementGroup
    }
  };
};
const loadingFlightControl = (payload) => {
  return {
    type: loadFlightControlActionTypes.LOADING,
    payload: { flightId: payload.flightId }
  };
};
const loadedFlightControl = (flightId, flightControl) => {
  return {
    type: loadFlightControlActionTypes.LOADED,
    payload: {
      flightId,
      flightControl
    }
  };
};
const loadControlTowerExperience = (flightId, workspaceId, managementGroup) => {
  return {
    type: loadControlTowerExperienceActionTypes.LOAD,
    payload: {
      flightId,
      workspaceId,
      managementGroup
    }
  };
};
const loadingControlTowerExperience = (payload) => {
  return {
    type: loadControlTowerExperienceActionTypes.LOADING,
    payload: { flightId: payload.flightId }
  };
};
const loadedControlTowerExperience = (payload, controlTowerExperience) => {
  return {
    type: loadControlTowerExperienceActionTypes.LOADED,
    payload: {
      flightId: payload.flightId,
      workspaceId: payload.workspaceId,
      managementGroup: payload.managementGroup,
      controlTowerExperience
    }
  };
};
const resetState = (flightId) => {
  return {
    type: flightDetailsActionTypes.RESET_STATE,
    payload: { flightId }
  };
};
export {
  createActionTypes,
  flightDetailsActionTypes,
  loadControlTowerExperience,
  loadControlTowerExperienceActionTypes,
  loadFlightControl,
  loadFlightControlActionTypes,
  loadedControlTowerExperience,
  loadedFlightControl,
  loadingControlTowerExperience,
  loadingFlightControl,
  resetState
};
//# sourceMappingURL=FlightDetails.ducks.js.map
